import { Block, Flex } from '@aloft/toolkit-sui';

import { memo } from 'react';

import { PropertyGrid } from '../../components/PropertyGrid/PropertyGrid.tsx';
import { useTkv2ReferenceBarEvents } from '../../components/ReferenceBar/useTkv2ReferenceBarEvents.ts';
import { FeatureGridDataSourcesSection } from './columnSections/FeatureGridDataSourcesSection.tsx';
import { FeatureGridFeatureSections } from './columnSections/FeatureGridFeatureSections.tsx';
import { FeatureGridMainDwellingSection } from './columnSections/FeatureGridMainDwellingSection.tsx';
import { FeatureGridSiteSection } from './columnSections/FeatureGridSiteSection.tsx';
import { FeatureGridTransactionSection } from './columnSections/FeatureGridTransactionSection.tsx';
import { FeatureGridToolbar } from './components/FeatureGridToolbar.tsx';

export const FeatureGridModule = memo(() => (
  <Flex
    {...useTkv2ReferenceBarEvents()}
    flexDirection="column"
    overflow="hidden"
    width="100%"
    gap={2}
  >
    <FeatureGridToolbar />
    <Block overflow="auto">
      <PropertyGrid
        gridType="FeatureGrid"
        columnSections={[
          FeatureGridDataSourcesSection,
          FeatureGridTransactionSection,
          FeatureGridSiteSection,
          FeatureGridMainDwellingSection,
          FeatureGridFeatureSections,
        ]}
      />
    </Block>
  </Flex>
));
